<template>
    <transition name="showHeader">
        <div class="header-animat">
            <a-layout-header class="ant-layout-header ant-header-fixedHeader ant-header-side-closed" style="padding: 0">
                <div  class="top-nav-header-index light">
                    <div class="header-index-wide">
                        <div class="header-index-left">
                            <logo/>
                            <!--<header-menu></header-menu>-->
                        </div>
                        <user-menu class="header-index-right"></user-menu>
                    </div>
                </div>
            </a-layout-header>
        </div>
    </transition>
</template>
<script>
    import Logo from './Logo.vue'
    import HeaderMenu from './HeaderMenu.vue'
    import UserMenu from './UserMenu.vue'
    export default {
        name: 'GlobalHeader',
        components: {
            Logo,
            HeaderMenu,
            UserMenu
        },
        props: {},
        data () {
            return {
                visible: true,
                oldScrollTop: 0
            }
        },
        mounted () {
        },
        methods: {}
    }
</script>

<style lang="less" scoped="">

</style>
